import { render, staticRenderFns } from "./AppReceiver.vue?vue&type=template&id=64fc46b7&scoped=true&"
import script from "./AppReceiver.vue?vue&type=script&lang=js&"
export * from "./AppReceiver.vue?vue&type=script&lang=js&"
import style0 from "./AppReceiver.vue?vue&type=style&index=0&id=64fc46b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc46b7",
  null
  
)

export default component.exports